import {useCallback, useContext} from 'react'

import Context from '@s-ui/react-context'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'

const getAnalytics = () =>
  new Promise(resolve => {
    // We check first if we have the UMD version of Segment Wrapper,
    // so that we return it instead of importing a new version.
    if (window.motor?.analytics) resolve(window.motor?.analytics)
    resolve(import('@adv-mt/mt-segment-wrapper').then(({default: analytics}) => analytics))
  })

const fakeTrack = event => {
  console.warn(`${event} can not be saved`) // eslint-disable-line no-console
}
const checkIsAnalyticsLoaded = () => Boolean(window?.analytics)

function useAnalyticsTrack() {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {TRACKING_DATA_BY_SITE, TRACKING_EVENT_NAMES: {SIGNED_OUT: signedOutEventName} = {}} = config.get('tracking')
  const delayToNextFrame = useDelayToNextFrame()

  const _onDispatchTrack = needsPage =>
    useCallback(
      async ({data: eventData, event, identify, reset, signOutWhenReset = true}) => {
        const isAnalyticsLoaded = checkIsAnalyticsLoaded()
        const data = {...TRACKING_DATA_BY_SITE, ...eventData}

        if (!isAnalyticsLoaded) return fakeTrack(event)

        const analytics = await getAnalytics()

        const resetActions = () => {
          signOutWhenReset && analytics.track(signedOutEventName)
          analytics.reset()
        }

        identify && analytics.identify(identify.userId, identify.data)
        reset && resetActions()
        if (event) {
          const trackMethodName = needsPage ? 'page' : 'track'

          delayToNextFrame(() => {
            analytics[trackMethodName](event, data)
          })
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    )

  return {track: _onDispatchTrack(false), page: _onDispatchTrack(true)}
}

export default useAnalyticsTrack
